/* eslint-disable no-unused-vars */
import React from 'react';

const AddIcon = props => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.472 12.945C6.23331 12.945 6.00439 12.8502 5.8356 12.6814C5.66682 12.5126 5.572 12.2837 5.572 12.045V0.9C5.572 0.661305 5.66682 0.432387 5.8356 0.263604C6.00439 0.0948211 6.23331 0 6.472 0C6.7107 0 6.93961 0.0948211 7.1084 0.263604C7.27718 0.432387 7.372 0.661305 7.372 0.9V12.045C7.372 12.2837 7.27718 12.5126 7.1084 12.6814C6.93961 12.8502 6.7107 12.945 6.472 12.945V12.945Z" fill="#4B9CE2"/>
    <path d="M12.045 7.37201H0.9C0.661305 7.37201 0.432387 7.27718 0.263604 7.1084C0.0948211 6.93962 0 6.7107 0 6.47201C0 6.23331 0.0948211 6.00439 0.263604 5.83561C0.432387 5.66683 0.661305 5.57201 0.9 5.57201H12.045C12.2837 5.57201 12.5126 5.66683 12.6814 5.83561C12.8502 6.00439 12.945 6.23331 12.945 6.47201C12.945 6.7107 12.8502 6.93962 12.6814 7.1084C12.5126 7.27718 12.2837 7.37201 12.045 7.37201Z" fill="#4B9CE2"/>
  </svg>

);

export default AddIcon;








